define(['text!./templates/editable-coverages.html', 'underscore', '../models/Coverage'],
    (templateStr, _, Coverage)=> {
        let guid = 0;

        return [()=> {
            return {
                restrict: 'A',
                template: templateStr,
                scope: {
                    coverages: '=gwQnbEditableCoverages',
                    loading: '=',
                    onCovChange: '=',
                    allowSelectCoverage: '=',
                    lob: '@'
                },
                controller: ['$scope', ($scope)=> {
                    $scope.uid = `covs${guid++}`;
                    $scope.showSelect = $scope.allowSelectCoverage;
                    function isLoading() {
                        return $scope.loading;
                    }

                    function onChange() {
                        if ($scope.onCovChange) {
                            $scope.onCovChange();
                        }
                    }

                coveragesArray = ['HODW_SectionI_Ded_HOE','HODW_Dwelling_Cov_HOE','HODW_Other_Structures_HOE','HODW_Personal_Property_HOE','HODW_Loss_Of_Use_HOE','HOLI_Personal_Liability_HOE','HOLI_Med_Pay_HOE'
                    ,'AdditionalAmtInsHOE_aaa','ReplacementCost_ContentsCovHOE_aaa','ReplacementCostDweling_aaa','Refrigerated_PP_CovHOE_aaa','AccidentalDeathHOE_aaa','Identity_Fraud_Exp_Cov_aaa','WaterBackup_Sump_CovHOE_aaa',
                    'HOLI_PersonalInjury_HOE','Service_Line_Coverage_aaa','Home_Systems_Protection_aaa','Inland_Flood_Coverage_aaa','zk4gep2qoal242a7j69fqqc2489','zbmheeo71ls731ema216p58g9t9','zugggoahqeqao6efk0m7r8afbja','CICovAHOE_aaa'];




                function setNewModel() {
                        $scope.model = $scope.coverages.map(_.partial(Coverage.create, _, isLoading, onChange));
                        if($scope.lob === 'Homeowners'){
                            $scope.filteredModel = _.filter($scope.model,function (item) {
                                if (coveragesArray.indexOf(item.publicID) != -1) return item;
                            });
                        }else{
                            $scope.filteredModel = $scope.model;
                        }
                    }

                    setNewModel();
                    $scope.$watch('coverages', setNewModel);
                }]
            };
        }];
    }
);



/** WEBPACK FOOTER **
 ** ./common/js/src/edge/quoteandbind/common/directives/EditableCoverages.js
 **/